/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Commitment_Body2Inputs */

const en_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`But rest assured, these changes will not affect your Pro status; You will permanently retain:`)
};

const ar_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لكن كن مطمئنًا، فلن تؤثر هذه التغييرات على حالة النسخة الا احترافي الخاصة بك؛ ستحتفظ بشكل دائم بما يلي:`)
};

const de_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aber seien Sie versichert, dass diese Änderungen keine Auswirkungen auf Ihren Pro Status haben werden; Sie werden dauerhaft beibehalten:`)
};

const es_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pero no te preocupes, estos cambios no afectarán a su estatus Pro; lo conservarás de forma permanente:`)
};

const fr_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soyez assuré(e) que ces changements n'affecteront pas votre statut Pro. Vous conserverez définitivement :`)
};

const it_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma stai tranquillo, questi cambiamenti non influenzeranno il tuo status Pro; Conserverai in modo permanente:`)
};

const ja_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ご安心ください。これらの変更によってProステータスが影響を受けることはありません。今後も引き続き下記ご利用いただけます。`)
};

const ko_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`하지만 이 같은 업데이트에도 회원님의 Pro 상태에는 영향을 미치지 않아요. 또한 다음 사항이 영구적으로 유지된답니다.`)
};

const pt_br_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mas tranquilize-se, pois essas alterações não afetarão seu status Pro; você reterá permanentemente:`)
};

const ru_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Будьте уверены, что эти изменения не повлияют на ваш статус Pro; вы навсегда сохраните:`)
};

const th_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่ต้องกังวลไป การเปลี่ยนแปลงนี้จะไม่ส่งผลต่อสถานะโปรของคุณ และคุณจะยังคงได้รับสิทธิ์ต่อไปนี้อย่างถาวร:`)
};

const tr_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ancak için rahat olsun, bu değişiklikler Pro statünü etkilemeyecek; şunları kalıcı olarak koruyacaksın:`)
};

const zh_cn_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`但请放心，这些改变都不会影响你专业版的身份，你将永久保留：`)
};

const zh_tw_pro_user_appreciation_letter_commitment_body2 = /** @type {(inputs: Pro_User_Appreciation_Letter_Commitment_Body2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`但請放心，這些改變都不會影響你專業版的身份，你將永久保留：`)
};

/**
* | output |
* | --- |
* | "But rest assured, these changes will not affect your Pro status; You will permanently retain:" |
*
* @param {Pro_User_Appreciation_Letter_Commitment_Body2Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_commitment_body2 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Commitment_Body2Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Commitment_Body2Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_commitment_body2(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_commitment_body2(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_commitment_body2(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_commitment_body2(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_commitment_body2(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_commitment_body2(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_commitment_body2(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_commitment_body2(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_commitment_body2(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_commitment_body2(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_commitment_body2(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_commitment_body2(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_commitment_body2(inputs)
	return zh_tw_pro_user_appreciation_letter_commitment_body2(inputs)
});